<template>
  <div v-if="aOrders.length > 0" class="new-order">
    <div
      v-for="(oOrder, iOrder) in aOrders"
      :key="iOrder"
      class="animate__animated"
      :class="changeClass"
    >
      <customer
        :design="'two'"
        :name="extractCustomerName(oOrder)"
        :phone="Utils.phoneMask(oOrder.payment.payers[0].user.phone)"
        :address="extractAddress(oOrder)"
        :payment="extractPaymentMethod(oOrder, 0)"
        :type="extractPayerUserType(oOrder, 0)"
        :orderTime="extractTimeOrder(oOrder)"
        :orderId="oOrder.position"
      />
      <base-card v-if="iOrder == 0">
        <div>
          <orders-products :items="oOrder.cart.catalog.items" />
        </div>
      </base-card>

      <!-- Payers -->
      <base-card v-if="oOrder.payment.payers.length > 0">
        <order-payers :payers="oOrder.payment.payers" />
      </base-card>

      <base-card>
        <order-prices
          :total="oOrder.cart.total"
          :delivery="oOrder.delivery.total"
          :gift="oOrder.gift"
        />
      </base-card>
    </div>
  </div>
</template>
<script>
import Utils from '@/utils';
import BrasilStates from '@/plugins/states';
import OrdersProducts from '@/containers/Orders/OrdersProducts';
import Order, { Status } from 'easyjs/lib/Schema/Order';
import { Method, PaymentMethod } from 'easyjs/lib/Schema/Payment';
import AppBridge from '@/plugins/app';
import OrderAPI from '@/api/order';
import Customer from '@/containers/Customer';
import OrderPrices from '@/containers/Orders/OrderPrices';
import OrderPayers from '@/containers/Orders/OrderPayers';
import DesktopBridge from '@/plugins/desktop';
import Builder from 'easyjs/lib/Schema/Components/Builder';
import SocketIO from 'easyjs/lib/Socket/SocketIO';

import BaseButton from '@/components/Button';
import BaseCard from '@/components/Card';

// import ring1 from '@/assets/mp3/ring-1.mp3'
// import ring2 from '@/assets/mp3/ring-2.mp3'
// import ring3 from '@/assets/mp3/ring-3.mp3'
// import ring4 from '@/assets/mp3/ring-4.mp3';
import ring5 from '@/assets/mp3/ring-5.mp3';

import { getXUserKey, getXAPIEnv } from '@/plugins/account';

import { DeliveryType } from 'easyjs/lib/Schema/Delivery';
import { mapState } from 'vuex';

export default {
  props: {
    newOrder: () => {},
    changeClass: { type: String, default: '' },
    enabledSound: { type: Boolean, default: true },
  },
  data() {
    return {
      BrasilStates,
      Method,
      Utils,
      orderStatuses: Status,
      aOrders: [],
      ringtone: null,
      firstLoggedRender: true,
      show: true,
    };
  },
  methods: {
    getPaymentMethod(oPayer) {
      const pM = oPayer[0].paymentMethod;
      let pMString = '';

      if ((pM & PaymentMethod.CREDIT) == PaymentMethod.CREDIT) {
        pMString = `(${StringLanguage.credit})`;
      } else if ((pM & PaymentMethod.DEBIT) == PaymentMethod.DEBIT) {
        pMString = `(${StringLanguage.debit})`;
      }

      if ((pM & PaymentMethod.ONLINE) == PaymentMethod.ONLINE) {
        pMString += StringLanguage.online;
      }

      return pMString;
    },
    extractCustomerName(oOrder) {
      const { payers } = oOrder.payment;

      if (payers[0] && payers[0].user && payers[0].user.name) {
        return payers[0].user.name;
      }
      return StringLanguage.customerNotAssigned;
    },
    extractAddress(oOrder) {
      if (oOrder.delivery.type == DeliveryType.DELIVER_ON_ADDRESS) {
        const shortNameState = BrasilStates.getShortNameByName(
          oOrder.delivery.address.state
        );
        return `${oOrder.delivery.address.address},
        ${oOrder.delivery.address.number} 
        ${
          oOrder.delivery.address.complement
            ? `(${oOrder.delivery.address.complement})`
            : ''
        } - 
        ${oOrder.delivery.address.region} - 
        ${oOrder.delivery.address.city}/
        ${shortNameState}`;
      }

      return 'Retirada no balcão';
    },
    extractPaymentMethod(oOrder, payerIndex) {
      return `${
        Method[oOrder.payment.payers[payerIndex].method].name
      } ${this.getPaymentMethod(oOrder.payment.payers)}`;
    },
    extractTimeOrder(oOrder) {
      if (!oOrder.created_at) return '';

      const milliseconds = Utils.toMilliseconds(oOrder.created_at);
      let temp = Math.floor(milliseconds / 1000);
      const days = Math.floor((temp %= 31536000) / 86400);

      if (days) {
        return Utils.dateParse(oOrder.created_at).replace(' ', ', ');
      }

      return `${StringLanguage.hasArrived} ${Utils.millisecondsToStr(
        milliseconds
      )}`;
    },
    extractPayerUserType(oOrder, payerIndex) {
      return (
        oOrder.payment.payers[payerIndex].user &&
        oOrder.payment.payers[payerIndex].user.type
      );
    },
    list() {
      const self = this;
      if (getXUserKey()) {
        OrderAPI.new(null, false).then((response) => {
          self.aOrders = [
            ...self.aOrders,
            ...response
              .getData([]).map((o) => Order.fromObject(o))
              .filter((o) => !this.postponedOrders.includes(o.id)),
          ];
        });
      }
    },
    startVibrate() {
      if (!this.ringtone) {
        this.ringtone = new Audio(ring5);
        this.ringtone.loop = true;
        this.ringtone.oncanplay = () => {
          this.ringtone.play();
        };
      }

      // AppBridge.emit("startVibration", [1000, 2000, 3000]);
    },
    stopVibrate() {
      if (this.ringtone) {
        this.ringtone.pause();
        this.ringtone.currentTime = 0;
        this.ringtone = null;
      }

      // AppBridge.emit("stopVibration", false);
    },
  },
  watch: {
    countOrders(iCount) {
      if (iCount > 0) {
        this.$emit('drawerOpen', iCount, this);
        if (DesktopBridge.isDesktop()) {
          DesktopBridge.emit('openNotification');
        }
      } else {
        this.$emit('drawerClose', iCount, this);
      }

      if (iCount + this.postponedOrders.length <= 1) {
        this.list();
      }

      this[`${iCount > 0 && this.enabledSound ? 'start' : 'stop'}Vibrate`]();
    },
    async newOrders(newOrders) {
      const newOrder = Order.fromObject(newOrders.data);
      this.aOrders.push(newOrder);
    },
    alreadyManipulatedOrders(alreadyManipulatedOrders) {
      const idsManipulatedOrder = alreadyManipulatedOrders.data.id;
      this.aOrders = this.aOrders.filter(
        (order) => order.id != idsManipulatedOrder
      );
    },
    postponedOrders(newPostponedOrders, oldPostponedOrders) {
      if (
        newPostponedOrders.length >= oldPostponedOrders.length &&
        newPostponedOrders.length > 0
      ) {
        this.aOrders = this.aOrders.filter(
          (order) => !newPostponedOrders.includes(String(order.id))
        );
      }
    },
    async oUser(oUser) {
      if (!!oUser.id && this.firstLoggedRender) {
        this.list();
        this.firstLoggedRender = false;
      }
      if (!oUser.id) {
        this.firstLoggedRender = true;
      }
    },
  },
  computed: {
    countOrders() {
      return this.aOrders.length;
    },
    ...mapState({
      newOrders: (state) => state.socket.newOrders,
      alreadyManipulatedOrders: (state) =>
        state.socket.alreadyManipulatedOrders,
      postponedOrders: (state) => state.socket.postponedOrders,
      oUser: (state) => state.account.oUser,
    }),
  },
  components: {
    BaseCard,
    BaseButton,
    OrdersProducts,
    OrderPrices,
    OrderPayers,
    Customer,
  },
};
</script>
<style scoped>
.new-order {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  padding-right: 15px;
}

.animate__animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animate__animated:not(:first-child) {
  display: none;
}

@-webkit-keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.animate__fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}

@-webkit-keyframes fadeOutRight {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
@keyframes fadeOutRight {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
.animate__fadeOutRight {
  -webkit-animation-name: fadeOutRight;
  animation-name: fadeOutRight;
}

@media screen and (max-width: 991px) {
  .new-order {
    margin-right: -15px;
  }
}
</style>
